export const HOME = '/';
export const WELCOME = 'welcome';
export const FEED = 'feed';
export const REELS = 'reels';
export const PROFILE = 'profile';
export const LIVE_STREAM = 'live-stream/:liveStreamId';
export const INFLUENCER = 'creators/:id';
export const FOLLOWING_INFLUENCERS = 'following-influencers';
export const CREATOR = 'creator';
export const FORBIDDEN = 'forbidden';
export const TERMS = 'TERMS';

export const CLOSE_BUTTON_ROUTES = [WELCOME, FEED, REELS, PROFILE, ''];
